<template>
  <sc-placeholder :name="rendering?.params?.sig || ''" :rendering="rendering" />
</template>

<script>
// import { defineComponent } from 'vue';
// import { defineAsyncComponent } from 'vue';
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';

//todo; use 'export default defineComponent(...' instead?
export default {
  // export default defineComponent({
  name: 'PartialDesignDynamicPlaceholder',
  props: {
    rendering: {
      type: Object
    }
  },
  components: {
    // ScPlaceholder: defineAsyncComponent(() => import('@sitecore-jss/sitecore-jss-vue'))
    ScPlaceholder: Placeholder
  },
  beforeCreate() {
    // console.log('PartialDesignDynamicPlaceholder.beforeCreate:fields', this.fields);
    // console.log('PartialDesignDynamicPlaceholder.beforeCreate:rendering', this.rendering);
  }
};
</script>
